import {
  AkaStudentProductIntroFormValues,
  CountryCode,
} from "Components/Features/CheckPrice/Products/AkaProducts/AkaStudent/ProductIntro/akaStudentProductIntroInterfaces";

import { AKA_STUDENT_ABOUT_YOU_STEP } from "Components/Features/CheckPrice/Products/AkaProducts/AkaStudent";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";

export interface AkaStudentProductBackend {
  name: INSURANCE_NAME_VALUE;
  coverageGroup: string;
  country: string;
  region: CountryCode;
  studiesAbroad: boolean;
}

export const mapToCommerceAkaStudent = (
  data: Record<string, any>,
): AkaStudentProductBackend => {
  const { country, region }: AkaStudentProductIntroFormValues =
    data.formData[AKA_STUDENT_ABOUT_YOU_STEP.id];

  return {
    name: INSURANCE_NAME_VALUE.AKA_STUDENT,
    coverageGroup: data.coverage,
    country,
    region,
    studiesAbroad: region !== CountryCode.NO,
  };
};
